import styled from '@emotion/styled';
import { theme } from '../../theme';
export const Container = styled.div `
	display: flex;
	align-items: center;
	padding: ${({ hasActions }) => hasActions ? '16px' : '24px'} 16px;
	position: relative;
`;
export const NavBarItem = styled.div `
	display: flex;
	justify-content: center;
	align-items: center;
`;
export const BackContainer = styled(NavBarItem) `
	margin-right: auto;
	justify-content: flex-start;
	max-width: 80px; // total width of 2 buttons plus spacing. This fixes truncation of title when 2 buttons are present.
	width: 80px;
`;
export const TitleContainer = styled(NavBarItem) `
	text-align: center;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	display: block;
	span {
		${theme.typography.IB100}
		line-height: ${theme.typography.lineHeight.sm};
		color: ${theme.colors.LM_NU100};
	}
`;
export const RightActionsContainer = styled(NavBarItem) `
	margin-left: auto;
	justify-content: flex-end;
	${({ numActions }) => numActions > 1 && 'button:first-of-type { margin-right: 8px; }'};
	max-width: 80px; // total width of 2 buttons plus spacing. This fixes truncation of title when 2 buttons are present.
	width: 80px;
`;
//# sourceMappingURL=NavigationBar.styled.js.map